import { Button } from '@mantine/core';
import { ButtonProps } from '@mantine/core';

interface CancelButtonProps extends ButtonProps {
    onClick: () => void;
}

export const CancelButton = ({ onClick, ...props }: CancelButtonProps) => (
    <Button variant="subtle" onClick={onClick} {...props}>
        Cancel
    </Button>
);